// Integrations available in the product's Settings → Integration (single source for the site).
import { VscAzureDevops } from "react-icons/vsc";
import browserstack from "../../../assets/icons/browserstack.png";
import jira from "../../../assets/icons/jira.png";
import plane from "../../../assets/icons/plane.png";
import github from "../../../assets/icons/git.png";
import gitlab from "../../../assets/icons/gitlab.png";
import froth from "../../../assets/logo.svg";

const AzureDevOpsLogo = () => <VscAzureDevops color="#0078D4" size={40} aria-hidden="true" />;

export const integrations = [
  {
    name: "Jira",
    logo: jira,
    text: "Sync requirements and defects with Jira, one-way or two-way, with custom field and user mapping.",
  },
  {
    name: "Azure DevOps",
    Logo: AzureDevOpsLogo,
    text: "Sync requirements and defects two-way with Azure DevOps work items, with custom field and user mapping.",
  },
  {
    name: "Plane",
    logo: plane,
    text: "Sync requirements and defects with Plane work items, one-way or two-way.",
  },
  {
    name: "GitHub",
    logo: github,
    text: "Map repositories, run automation on self-hosted GitHub Actions runners, push API and automation scripts, and scan code with the Code Analyzer.",
  },
  {
    name: "GitLab",
    logo: gitlab,
    text: "Map repositories, run automation through GitLab Runner and scan code for vulnerabilities and leaked secrets.",
  },
  {
    name: "BrowserStack",
    logo: browserstack,
    text: "Run cross-browser and real-device tests on BrowserStack, with a built-in capability generator for Android, iOS and desktop browsers.",
  },
];

export function IntegrationLogo({ item }) {
  return item.Logo ? <item.Logo /> : <img src={item.logo} alt="" width="40" height="40" />;
}

// Hero illustration: the platform in the middle with every integration orbiting it.
export function IntegrationOrbit() {
  return (
    <div className="ft-orbit" role="img" aria-label={`Froth TestOps connects with ${integrations.map(i => i.name).join(", ")}`}>
      <div className="ft-orbit__ring ft-orbit__ring--outer" />
      <div className="ft-orbit__ring ft-orbit__ring--inner" />
      <div className="ft-orbit__hub">
        <img src={froth} alt="" width="120" height="44" />
      </div>
      <div className="ft-orbit__track">
        {integrations.map((item, i) => (
          <span className="ft-orbit__item" key={item.name} style={{ "--i": i, "--n": integrations.length }}>
            <span className="ft-orbit__logo" title={item.name}>
              <IntegrationLogo item={item} />
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
